export default "__VITE_ASSET__oOcJCIZJ__"